import React from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppCtaProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  showIcon?: boolean;
  variant?: 'primary' | 'outline' | 'floating';
}
export function WhatsAppCta({
  className = '',
  size = 'md',
  text = 'Chat on WhatsApp',
  showIcon = true,
  variant = 'primary'
}: WhatsAppCtaProps) {
  const phoneNumber = '447921876472';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2';
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl w-full sm:w-auto'
  };
  const variantStyles = {
    primary: 'bg-green-600 hover:bg-green-500 text-white shadow-lg hover:shadow-green-500/30 hover:-translate-y-0.5',
    outline: 'border-2 border-green-600 text-green-600 hover:bg-green-50',
    floating: 'fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-400 text-white shadow-xl p-4 hover:scale-110'
  };
  if (variant === 'floating') {
    return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variantStyles.floating} ${className}`} aria-label="Contact us on WhatsApp" data-id="element-122">
        <MessageCircle className="w-8 h-8" data-id="element-123" />
      </a>;
  }
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${className}`} data-id="element-124">
      {showIcon && <MessageCircle className={`mr-2 ${size === 'xl' ? 'w-6 h-6' : 'w-5 h-5'}`} data-id="element-125" />}
      {text}
    </a>;
}